module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDMwMCAyMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMCAwaDMwMHYyMDBIMHoiLz48cGF0aCBmaWxsPSIjQ0UxMTI2IiBkPSJNMCAwaDMwMHY2Ni42NjdIMHoiLz48cGF0aCBmaWxsPSIjMDAwIiBkPSJNMCAxMzMuMzMzaDMwMFYyMDBIMHoiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-ye.svg
// module id = MTmY
// module chunks = 2